import React, { useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";

const TransactionStatusSelect = ({ checkedStatus, setCheckedStatus, defaultOption = false }) => {
  const { t } = useTranslation("otherInterface");

  const [statuses, setStatuses] = useState([
    "NEW",
    "PROCESSED",
    "PENDING",
    "FAIL"
  ]);

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedStatus(data);
  };

  return (
    <FormControl>
      <InputLabel id="demo-simple-select-label">{t("status.title")}</InputLabel>
      {/* No need to change on Autocomplete component (statuses) */}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={checkedStatus}
        onChange={handleChangeSelect}
      >
        {defaultOption && <MenuItem value={null}>{t("status.all")}</MenuItem>}
        {statuses.map((status, key) => (
          <MenuItem
            key={key}
            value={status}
          >
            {status}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TransactionStatusSelect;